interface ILog {
  txt?: string;
  error?: Error;
  obj?: any;
}

export const logInfo = ({ txt, obj }: ILog) => {
  console.info(txt);

  if (obj) {
    if (process.env.CLAYTON_ENVIRONMENT === 'itg') {
      console.info(obj, null, 4);
    } else {
      console.info(JSON.stringify(obj));
    }
  }
};

export const logError = ({ error, obj }: ILog) => {
  const timestamp = new Date().toLocaleTimeString();
  console.error(error, timestamp);

  if (obj) {
    if (process.env.CLAYTON_ENVIRONMENT === 'itg') {
      console.error(obj, null, 4);
    } else {
      console.error(JSON.stringify(obj));
    }
  }
};
